// extracted by mini-css-extract-plugin
export default {"styled_statistic_button":"styled_styled_statistic_button__ogXof"};